var _excluded = ["rowIndex", "rowHeight", "treeEmpty", "expansionContent", "children", "className", "style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useTableImplement, useTableCep } from '../implements/implement';
export function TableRow(props) {
  var rowIndex = props.rowIndex,
      rowHeight = props.rowHeight,
      treeEmpty = props.treeEmpty,
      expansionContent = props.expansionContent,
      children = props.children,
      className = props.className,
      style = props.style,
      attrs = _objectWithoutProperties(props, _excluded);

  var _useTableCep = useTableCep(),
      elem = _useTableCep.elem;

  var _useTableImplement = useTableImplement(),
      TR = _useTableImplement.TR;

  return React.createElement(TR, _objectSpread(_objectSpread({}, attrs), {}, {
    className: elem('Row', {
      treeEmpty: treeEmpty,
      expansionContent: expansionContent
    }, className),
    style: _objectSpread(_objectSpread({}, style), {}, {
      height: rowHeight && "".concat(rowHeight, "px")
    }),
    role: "row",
    "aria-rowindex": rowIndex
  }), children);
}